<script>
import emit from 'vue-emit';
import { colorsCategorical } from '@/constants';
import IconCheck from '@/components/icons/Check';

const propTypes = {
  value: {
    type: String,
    required: true,
  },
  static: {
    type: Boolean,
    default: false,
  },
};

const handleInput = listeners => e => {
  const { color } = e.target.dataset;

  if (color) {
    emit(listeners, 'change', color);
  }
};

const DepartmentColorInput = ({ $style, props, listeners }) => (
  <div
    class={$style.wrapper}
    role="presentation"
    onClick={handleInput(listeners)}
  >
    {!props.static
      ? colorsCategorical.map(color => (
        <button
          key={color}
          type="button"
          class={[
            $style.option,
            { [$style.selected]: color === props.value },
          ]}
          data-color={color}
          style={{ color }}
        >
          <IconCheck class={$style.icon} />
        </button>
      ))
      : (
        <span
          class={[$style.option, $style.selected]}
          style={{ color: props.value }}
        >
          <IconCheck class={$style.icon} />
        </span>
      )}
  </div>
);

DepartmentColorInput.props = propTypes;

export default DepartmentColorInput;
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.wrapper {
  display: flex;
}

.option {
  @include button-reset();

  align-items: center;
  background-color: currentColor;
  border-radius: 50%;
  display: flex;
  height: 2em;
  justify-content: center;
  opacity: .75;
  transition: opacity .2s;
  width: 2em;

  & + & {
    margin-left: .25em;
  }

  &:hover,
  &:focus {
    opacity: 1;
  }

  & > .icon {
    color: $color-white;
    opacity: 0;
    transition: opacity .2s;
  }

  &.selected {
    opacity: 1;

    & > .icon {
      opacity: 1;
    }
  }
}
</style>
